import React from 'react';
import {connect} from 'react-redux';
import {submit, startSubmit, isInvalid, isSubmitting} from 'redux-form';

import {MODALS, fetchLegacyDocuments} from 'ducks/bookings';
import {selectModal} from 'ducks/modals';
import {default as Modal, withModal} from 'components/Modal';

import {
  LegacyDocumentUploadButtons,
  LegacyDocumentUploadForm
} from './components';

import './styles.css';

class LegacyDocumentUploadModal extends React.Component<any> {
  submitForm = () => {
    this.props.submit('legacyDocumentUpload');
  };

  getExtraActions = () => [
    ...this.props.closeModalExtraActions,
    () => fetchLegacyDocuments({bookingId: this.props.data.bookingId})
  ];

  render() {
    const {form: {submitting, invalid}, uploading} = this.props;
    const submitDisabled = submitting || invalid || uploading;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        type={Modal.MEDIUM}
        className="LegacyDocumentUploadModal">
        <Modal.Header heading="Upload a Document" />
        <Modal.Body>
          <LegacyDocumentUploadForm
            getExtraActions={this.getExtraActions}
            storeDataExtraActions={this.props.storeDataExtraActions}
          />
        </Modal.Body>
        <Modal.Footer>
          <LegacyDocumentUploadButtons
            submitForm={this.submitForm}
            submitDisabled={submitDisabled}
            submitting={submitting}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const {data: {uploading}} = selectModal(state, MODALS.LEGACY_DOCUMENT_UPLOAD);

  return {
    uploading,
    form: {
      invalid: isInvalid('legacyDocumentUpload')(state),
      submitting: isSubmitting('legacyDocumentUpload')(state)
    }
  };
};

const mapDispatchToProps = {startSubmit, submit};

export default connect(mapStateToProps, mapDispatchToProps)(
  withModal(MODALS.LEGACY_DOCUMENT_UPLOAD)(LegacyDocumentUploadModal)
);
